import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Table } from 'semantic-ui-react'
import { Link } from 'react-router'

import MySearchesTableHeader from 'Components/MySearchesTableHeader'
import PopupButton from 'Components/PopupButton'

import * as styles from './styles'

import { getFormattedDateString } from 'Global/Helpers/timeHelpers'

class MySearchesTable extends Component {
  static propTypes = {
    deleteSearch: PropTypes.func.isRequired,
    handleSort: PropTypes.func.isRequired,
    searches: PropTypes.array.isRequired,
    sortBy: PropTypes.string.isRequired,
    sortOrder: PropTypes.string.isRequired,
  }

  handleDelete = (id, e) => {
    const { deleteSearch } = this.props

    e.preventDefault()

    deleteSearch(id)
  }

  render() {
    const { handleSort, sortBy, sortOrder, searches } = this.props

    const mappedSearches = searches.map(search => {
      return (
        <Table.Row key={search.id}>
          <Table.Cell>
            <Link
              to={{
                pathname: `/search`,
                query: { params: JSON.stringify(search.params) },
              }}
              style={styles.link}
            >
              {search.name}
            </Link>
          </Table.Cell>
          <Table.Cell>{search.rugs}</Table.Cell>
          <Table.Cell>{getFormattedDateString(search.createdAt)}</Table.Cell>
          <Table.Cell>
            <PopupButton icon="trash" onClick={this.handleDelete.bind(this, search.id)} popupContent="Delete Search" />
          </Table.Cell>
        </Table.Row>
      )
    })

    return (
      <Table columns={2} size="small" fixed selectable sortable>
        <MySearchesTableHeader handleSort={handleSort} sortBy={sortBy} sortOrder={sortOrder} />

        <Table.Body>{mappedSearches}</Table.Body>
      </Table>
    )
  }
}

export default MySearchesTable
